<template>
    <main-content v-if="form_data.user_type">
        <kt-panel>
            <kt-panel-body>
                <p style="font-size: medium"> {{ $t('application.add_new_application') }}</p>
                <form id="create_application_form"
                      style="margin-top: 15px">
                    <kt-row>
                        <kt-col xs="12" sm="6" md="4" lg="3">
                            <kt-form-group>
                                <kt-form-label for="title">
                                    {{ $t('application.title') }}
                                </kt-form-label>
                                <kt-form-control dir="rtl" v-model="form_data.title" name="title"
                                                 id="title"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <div v-if="form_data.user_type === userTypes.LEGAL">
                        <signature-holders :signature_holders="form_data.signature_holders"></signature-holders>
                    </div>
                    <hr>
                    <p style="font-size: medium">
                        {{ $t('application.access_ips') }}
                    </p>
                    <div style="margin-top: 10px" class="col-lg-8 col-md-8 col-sm-12 col-xs-12" id="access_ips_div"
                         v-for="(access_ip,index) in form_data.access_ips" v-bind:key="'access_ip'+index">
                        <kt-row>
                            <kt-col xs="9" sm="9">
                                <kt-form-group>
                                    <kt-form-control :value="access_ip" dir="ltr"
                                                     :name="'access_ips.'+index"
                                                     v-model="form_data.access_ips[index]"
                                                     :id="index"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="3" sm="3">
                                <kt-form-group>
                                    <a @click="deleteAccessIp(index)"
                                       class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                                        <i class="la la-trash-o"></i>
                                        {{ $t('btn.delete') }}
                                    </a>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </div>
                    <kt-row id="add_access_ip">
                        <kt-row class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                            <kt-col xs="9" sm="9" lg="9">
                                <kt-form-group>
                                    <kt-form-control dir="ltr" v-model="new_access_ip"
                                                     name="access_ips"
                                                     id="access_ips"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="3" sm="3" lg="3">
                                <kt-form-group hor style="margin-right: 2%">
                                    <a style="padding-top: 5%" @click="addAccessIp()"
                                       class="btn btn-bold btn-sm btn-label-brand">
                                        <i class="la la-plus"></i> {{ $t('btn.add') }}
                                    </a>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </kt-row>
                    <hr>
                    <div>
                        <p class="col-12" style="font-size: medium;margin-top: 20px;margin-bottom: 25px"> {{ $t('application.choose_app_services') }}</p>

                        <application-services :form_data="form_data.services"></application-services>
                    </div>
                    <div v-show="show_accounts">
                        <application-accounts :accounts="form_data.accounts"></application-accounts>
                    </div>
                    <div>

                        <kt-col lg="12" xs="12" sm="12" style="margin-top: 130px">
                            <kt-form-action class="mt-4">
                                <kt-button
                                        style="position: absolute;left: 0;bottom: 0"
                                        class="m-2 btn-wide"
                                        size="md"
                                        variant="success"
                                        type="button"
                                        v-bind:wide="true"
                                        id="submit_create_application_btn"
                                        @click="createApplication()"
                                >
                                    {{ $t('btn.register') }}
                                </kt-button>
                            </kt-form-action>
                        </kt-col>
                    </div>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import {KTApp} from "@/plugins/core/app";
import {openBankingService} from "@/common/api.service";
import $ from "jquery";
import toastr from "toastr";
import {i18n} from '@/plugins/i18n';
import mainContent from '@/components/main-content'
import {userTypes, userTypesStr} from '@/constants/userTypes'
import {financialServices} from '@/constants/openBanking'
import {mapGetters} from "vuex";
import ApplicationServices from './components/application-services'
import ApplicationBankAccounts from './components/application-bank-accounts.vue'
import SignatureHolders from './components/signature-holders';
import IranSheba from "iran-sheba";
import {bankId} from "@/constants/bankId";


export default {
    components: {
        'signature-holders': SignatureHolders,
        'application-services': ApplicationServices,
        'application-accounts': ApplicationBankAccounts,
        'main-content': mainContent,
    },
    data() {
        return {
            show_accounts : false,
            bankId,
            financialServices,
            form_data: {
                access_ips: [],
                signature_holders: [],
                services: {
                    internal_transfer: {is_selected: false, status: null},
                    paya_transfer: {is_selected: false, status: null},
                    satna_transfer: {is_selected: false, status: null},
                    card_to_iban: {is_selected: false, status: null},
                    // card_to_account: {is_selected: false, status: null},
                    iban_to_account: {is_selected: false, status: null},
                    account_to_iban: {is_selected: false, status: null},
                    invoice: {is_selected: false, status: null},
                    // satna_report: {is_selected: false, status: null},
                    // paya_report: {is_selected: false, status: null},
                    matching_national_id_mobile: {is_selected: false, status: null},
                    // postal_code_information: {is_selected: false, status: null},
                    iban_inquiry: {is_selected: false, status: null},
                    // card_owner_information_inquiry: {is_selected: false, status: null},
                    // account_owner_name_inquiry: {is_selected: false, status: null},
                    // card_inquiry: {is_selected: false, status: null},
                    matching_card_national_id_birth_date_inquiry: {is_selected: false, status: null},
                    matching_iban_national_id_birth_date_inquiry: {is_selected: false, status: null},
                    balance: {is_selected: false, status: null},
                    // matching_iban_national_id_inquiry: {is_selected: false, status: null},
                },
                accounts: [
                    {
                        bank_id: '',
                        account_number: '',
                        iban: '',
                        shahab_code: '',
                    }
                ],
            },
            new_access_ip: null,
            userTypes,
            userTypesStr
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    beforeMount() {
        if(this.current_user.user_type == userTypes.LEGAL) {
            this.form_data.signature_holders.push({
                national_code: this.current_user.signature_holder.national_code,
                first_name_fa: this.current_user.signature_holder.first_name_fa,
                first_name_en: this.current_user.signature_holder.first_name_en,
                last_name_fa: this.current_user.signature_holder.last_name_fa,
                last_name_en: this.current_user.signature_holder.last_name_en,
                father_name_fa: this.current_user.signature_holder.father_name_fa,
                father_name_en: this.current_user.signature_holder.father_name_en,
                birth_date: this.current_user.signature_holder.birth_date,
            });
        }
        this.form_data.user_type = this.current_user.user_type;
    },
    mounted() {
        this.afterDispatch()
    },
    watch :{
        form_data: {
            handler(newValue, oldValue) {
                var count = 0;
               for (var prop in this.financialServices){
                   if (newValue.services[this.financialServices[prop]].is_selected) {
                       count++
                       break
                   }
               }
               if (count > 0) {
                   this.show_accounts = true;
                   if (this.form_data.accounts.length < 1){
                       this.form_data.accounts.push({
                           bank_id: '',
                           account_number: '',
                           iban: '',
                           shahab_code: '',
                       })
                   }
               }
               else this.show_accounts = false
            },
            deep: true

        },

    },
    methods: {
        createApplication() {
            let form = $('#create_application_form')
            let btn = $('#submit_create_application_btn')

            if (this.current_user.user_type == userTypes.LEGAL && this.form_data.signature_holders.length < 1)
                return this.toastr.error(i18n.t('application.message.signature_holder_required'))


            if (this.validateSignatureHolders())
                return;

            if (this.form_data.access_ips.length < 1)
                return this.toastr.error(i18n.t('application.message.access_ip_required'))

            var need_account = false;
            for (var financial_srvice in this.financialServices) {
                let service = financial_srvice +''
                service = service.toLowerCase()
                if (this.form_data.services[service].is_selected) {
                    need_account = true;
                    break;
                }
            }
            if (need_account){
                if (this.form_data.accounts.length < 1)
                    return this.toastr.error(i18n.t('application.message.minimum_bank_account'))
                if (this.validateAccounts())
                    return;
            }

            form.validate({
                lang: 'fa',
                rules: {
                    title: {
                        required: true
                    },
                    access_ips: {
                        required: () => {
                            if (this.form_data.access_ips.length < 1) return true;
                            else return false
                        },
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            console.log('5')

            let services = this.getServices();
            let params = structuredClone(this.form_data)
            delete params.services
            if (!this.show_accounts || params.accounts.length < 1)
                  params.accounts = []
            else {
                var all_ibans = []
                for (var prop in params.accounts) {
                    params.accounts[prop].iban = this.correctFormatSheba(params.accounts[prop].iban)
                    all_ibans.push(params.accounts[prop].iban)
                }
                var duplicates = all_ibans.filter((item, index) => all_ibans.indexOf(item) !== index);
                if (duplicates.length > 0)
                    return this.toastr.error(i18n.t('application.message.duplicate_bank_accounts'))
            }
            KTApp.progress(btn)
            openBankingService.createApplication({...params,...services}).then(response => {
                this.toastr.success(response.data.message)
                this.$router.push('/applications')
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            )
        },
        addAccessIp() {
            var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
            if (!ip_regex.test(this.new_access_ip))
                return this.toastr.error(i18n.t('application.message.invalid_ip_format'))

            for (var i = 0; i < this.form_data.access_ips.length; i++) {
                if (this.form_data.access_ips[i] === this.new_access_ip)
                    return this.toastr.error(i18n.t('application.message.ip_is_duplicate'))
            }

            this.form_data.access_ips.push(this.new_access_ip)
            if (this.form_data.access_ips.length >= 4)
                document.getElementById('add_access_ip').style.display = 'none'
            this.new_access_ip = null
        },
        deleteAccessIp(index) {
            this.form_data.access_ips.splice(index, 1)

            if (this.form_data.access_ips.length < 4)
                document.getElementById('add_access_ip').style.display = 'block'
        },
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }), 2000)
        },
        validateSignatureHolders() {
            if (this.current_user.user_type == userTypes.REAL || this.form_data.signature_holders.length < 1)
                return false;
            let has_error = false;
            for (let i = 0; i < this.form_data.signature_holders.length; i++) {
                if (!this.form_data.signature_holders[i].first_name_fa) {
                    document.getElementById('signature_holder_first_name_fa_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_first_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else if(!this.checkIfIsPersian(this.form_data.signature_holders[i].first_name_fa)){
                    document.getElementById('signature_holder_first_name_fa_error' + i).innerText = i18n.t('pos.validations.enter_persian')
                    document.getElementById('signature_holder_first_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else{
                    document.getElementById('signature_holder_first_name_fa_error' + i).innerText = ''
                    document.getElementById('signature_holder_first_name_fa' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.form_data.signature_holders[i].first_name_en) {
                    document.getElementById('signature_holder_first_name_en_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_first_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsEnglish(this.form_data.signature_holders[i].first_name_en)) {
                    document.getElementById('signature_holder_first_name_en_error' + i).innerText = i18n.t('pos.validations.enter_english')
                    document.getElementById('signature_holder_first_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_first_name_en_error' + i).innerText = ''
                    document.getElementById('signature_holder_first_name_en' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.form_data.signature_holders[i].last_name_fa) {
                    document.getElementById('signature_holder_last_name_fa_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_last_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else if(!this.checkIfIsPersian(this.form_data.signature_holders[i].last_name_fa)) {
                    document.getElementById('signature_holder_last_name_fa_error' + i).innerText = i18n.t('pos.validations.enter_persian')
                    document.getElementById('signature_holder_last_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_last_name_fa_error' + i).innerText = ''
                    document.getElementById('signature_holder_last_name_fa' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.form_data.signature_holders[i].last_name_en) {
                    document.getElementById('signature_holder_last_name_en_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_last_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsEnglish(this.form_data.signature_holders[i].last_name_en)) {
                    document.getElementById('signature_holder_last_name_en_error' + i).innerText = i18n.t('pos.validations.enter_english')
                    document.getElementById('signature_holder_last_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_last_name_en_error' + i).innerText = ''
                    document.getElementById('signature_holder_last_name_en' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.form_data.signature_holders[i].father_name_fa) {
                    document.getElementById('signature_holder_father_name_fa_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_father_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }  else if(!this.checkIfIsPersian(this.form_data.signature_holders[i].father_name_fa)) {
                    document.getElementById('signature_holder_father_name_fa_error' + i).innerText = i18n.t('pos.validations.enter_persian')
                    document.getElementById('signature_holder_father_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else {
                    document.getElementById('signature_holder_father_name_fa_error' + i).innerText = ''
                    document.getElementById('signature_holder_father_name_fa' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.form_data.signature_holders[i].father_name_en) {
                    document.getElementById('signature_holder_father_name_en_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_father_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsEnglish(this.form_data.signature_holders[i].father_name_en)) {
                    document.getElementById('signature_holder_father_name_en_error' + i).innerText = i18n.t('pos.validations.enter_english')
                    document.getElementById('signature_holder_father_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_father_name_en_error' + i).innerText = ''
                    document.getElementById('signature_holder_father_name_en' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.form_data.signature_holders[i].birth_date) {
                    document.getElementById('signature_holder_birth_date_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_birth_date' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_birth_date_error' + i).innerText = ''
                    document.getElementById('signature_holder_birth_date' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.form_data.signature_holders[i].national_code) {
                    document.getElementById('signature_holder_national_code_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_national_code' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_national_code_error' + i).innerText = ''
                    document.getElementById('signature_holder_national_code' + i).style.borderColor = '#e2e5ec'
                }
            }

            return has_error;
        },
        getServices() {
            return {
                internal_transfer: this.form_data.services.internal_transfer.is_selected,
                paya_transfer: this.form_data.services.paya_transfer.is_selected,
                satna_transfer: this.form_data.services.satna_transfer.is_selected,
                card_to_iban: this.form_data.services.card_to_iban.is_selected,
                // card_to_account: this.form_data.services.card_to_account.is_selected,
                iban_to_account: this.form_data.services.iban_to_account.is_selected,
                account_to_iban: this.form_data.services.account_to_iban.is_selected,
                invoice: this.form_data.services.invoice.is_selected,
                // satna_report: this.form_data.services.satna_report.is_selected,
                // paya_report: this.form_data.services.paya_report.is_selected,
                matching_national_id_mobile: this.form_data.services.matching_national_id_mobile.is_selected,
                // postal_code_information: this.form_data.services.postal_code_information.is_selected,
                iban_inquiry: this.form_data.services.iban_inquiry.is_selected,
                // card_owner_information_inquiry: this.form_data.services.card_owner_information_inquiry.is_selected,
                // account_owner_name_inquiry: this.form_data.services.account_owner_name_inquiry.is_selected,
                // card_inquiry: this.form_data.services.card_inquiry.is_selected,
                matching_card_national_id_birth_date_inquiry: this.form_data.services.matching_card_national_id_birth_date_inquiry.is_selected,
                matching_iban_national_id_birth_date_inquiry: this.form_data.services.matching_iban_national_id_birth_date_inquiry.is_selected,
                // matching_iban_national_id_inquiry: this.form_data.services.matching_iban_national_id_inquiry.is_selected,
            }
        },
        validateAccounts(){
            let has_error = false;
            for (let i = 0; i < this.form_data.accounts.length; i++) {
                if (!this.form_data.accounts[i].bank_id) {
                    document.getElementById('account_bank_id_error' + i).innerText = i18n.t('application.validations.required')
                    document.getElementById('account_bank_id' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('account_bank_id_error' + i).innerText = ''
                    document.getElementById('account_bank_id' + i).style.borderColor = '#e2e5ec'
                }
                if (!this.form_data.accounts[i].first_name) {
                    document.getElementById('account_first_name_error' + i).innerText = i18n.t('application.validations.required')
                    document.getElementById('account_first_name' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('account_first_name_error' + i).innerText = ''
                    document.getElementById('account_first_name' + i).style.borderColor = '#e2e5ec'
                }
                if (!this.form_data.accounts[i].last_name) {
                    document.getElementById('account_last_name_error' + i).innerText = i18n.t('application.validations.required')
                    document.getElementById('account_last_name' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('account_last_name_error' + i).innerText = ''
                    document.getElementById('account_last_name' + i).style.borderColor = '#e2e5ec'
                }
                if (!this.form_data.accounts[i].account_number) {
                    document.getElementById('account_account_number_error' + i).innerText = i18n.t('application.validations.required')
                    document.getElementById('account_account_number' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('account_account_number_error' + i).innerText = ''
                    document.getElementById('account_account_number' + i).style.borderColor = '#e2e5ec'
                }
                if (!this.form_data.accounts[i].iban) {
                    document.getElementById('account_iban_error' + i).innerText = i18n.t('application.validations.required')
                    document.getElementById('account_iban' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    let sheba = this.correctFormatSheba(this.form_data.accounts[i].iban)
                    if (!IranSheba.isValid(sheba)) {
                        document.getElementById('account_iban_error' + i).innerText = i18n.t('deposit.message.sheba_is_not_valid')
                        document.getElementById('account_iban' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else if (this.form_data.accounts[i].bank_id == this.bankId.saderat &&
                        IranSheba.recognize(sheba).nickname != 'saderat') {
                        document.getElementById('account_iban_error' + i).innerText = i18n.t('deposit.message.sheba_does_not_belong_to_saderat')
                        document.getElementById('account_iban' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else if (this.form_data.accounts[i].bank_id == this.bankId.keshavarzi &&
                        IranSheba.recognize(sheba).nickname != 'keshavarzi') {
                        document.getElementById('account_iban_error' + i).innerText = i18n.t('deposit.message.sheba_does_not_belong_to_keshavarzi')
                        document.getElementById('account_iban' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else if (this.form_data.accounts[i].bank_id == this.bankId.saman &&
                        IranSheba.recognize(sheba).nickname != 'saman') {
                        document.getElementById('account_iban_error' + i).innerText = i18n.t('deposit.message.sheba_does_not_belong_to_saman')
                        document.getElementById('account_iban' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else {
                        document.getElementById('account_iban_error' + i).innerText = ''
                        document.getElementById('account_iban' + i).style.borderColor = '#e2e5ec'
                    }
                }
            }
            return has_error
        },
        correctFormatSheba(sheba) {
           sheba= sheba.split('-').join('')
           sheba= sheba.split('_').join('')
           return sheba.split(' ').join('')
        },
    }
}
</script>

<style>
.modal .modal-content .modal-header .close:before {
    content: "" !important;
}

.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: .7;
}
</style>